import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { TwitterPublishForm } from './TwitterPublishForm';
import { TwitterSettingsForm } from './TwitterSettingsForm';

export const useTwitterExport: ExportFormHook<
  socialExport.TwitterPublishDto,
  socialExport.TwitterSettingsDto
> = () => {
  return {
    PublishForm: TwitterPublishForm,
    SettingsForm: TwitterSettingsForm,
  };
};
